module.exports = __webpack_public_path__ + "img/huangjianhua.f4a1951f.jpg";